import apiClient from "./apiClient";

export const sendTermsUpdateNotification = async (): Promise<void> => {
    try {
        await apiClient.post("/notification/terms-update");
    } catch (error) {
        console.error("Failed to send terms update.", error);
        throw error;
    }
};

export const sendPrivacyPolicyUpdateNotification = async (): Promise<void> => {
    try {
        await apiClient.post("/notification/privacy-policy-update");
    } catch (error) {
        console.error("Failed to send privacy policy update.", error);
        throw error;
    }
};
